import { gsap } from 'gsap';
import { productCardSetup, productCardEnter } from './product-card';

function relatedProductsSetup(el) {
  const title = el.querySelector('.collection-grid__header-title');
  const { children:items } = el.querySelector('.collection-grid__grid');

  if (title) gsap.set(title, { y: -10, autoAlpha: 0 });
  if (items) [...items].forEach(item => productCardSetup(item));

}

function relatedProductsEnter(el) {
  const title = el.querySelector('.collection-grid__header-title');
  const { children:items } = el.querySelector('.collection-grid__grid');


  const tl = gsap.timeline({ defaults: { duration: 1, ease: 'power2.out' } });
  tl.to(title, {y: 0, autoAlpha: 1}, 0);
  if (items) [...items].forEach((item, i) => tl.add(() => productCardEnter(item), 0.1 * i));
}

export { relatedProductsSetup, relatedProductsEnter };